import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Breadcrumb from '../../components/Breadcrumb';
import {
  Biohazard,
  BookOpen,
  ClipboardList,
  Users,
  CheckCircle2,
  Loader2,
  CheckCircle,
  XCircle,
} from 'lucide-react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const InfectionPrevention = () => {
  const [qualification, setQualification] = useState('');
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    designation: '',
    gender: '',
    age: '',
    institute: '',
    qualification: '',
    otherQualification: '',
    email: '',       // ✅ added
    phone: '',       // ✅ added
    attachment: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  const payload = new FormData();
  Object.keys(formData).forEach((key) => {
    payload.append(key, formData[key]);
  });

  try {
    const res = await fetch('https://ricgop.online/backend/ipc/register.php', {
      method: 'POST',
      body: payload,
    });
    const result = await res.json();

    if (result.status === 'success') {
      Swal.fire({
        icon: 'success',
        title: 'Application Submitted',
        text: 'Your application submitted successfully, we will verify your information and contact you shortly via email / sms.',
        toast: true,
        position: 'center',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true,
      });

      // Reset form
      setFormData({
        firstName: '',
        lastName: '',
        designation: '',
        gender: '',
        age: '',
        institute: '',
        qualification: '',
        otherQualification: '',
        email: '',
        phone: '',
        attachment: null,
      });
      setQualification('');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Submission Error',
        text: result.message || 'Something went wrong. Please try again.',
        position: 'center',
        confirmButtonText: 'OK',
      });
    }
  } catch (error) {
    Swal.fire({
      icon: 'error',
      title: 'Submission Failed',
      text: error.message || 'Unable to submit your application.',
      position: 'center',
      confirmButtonText: 'OK',
    });
  } finally {
    setLoading(false);
  }
};


  const IconList = ({ items }) => (
    <ul className="it-custom-list">
      {items.map((item, i) => (
        <li key={i}>
          <CheckCircle2 className="text-success me-2" size={18} />
          {item}
        </li>
      ))}
    </ul>
  );

  return (
    <main>
      <Breadcrumb title="IPC Workshop" subTitle="Infection Prevention & Control" />

      <div className="it-sv-details__area pt-120 pb-100">
        <div className="container">
          <div className="row">
            {/* Main Content */}
            <div className="col-xl-9 col-lg-9">
              <div className="it-sv-details__left">
                {/* Header */}
                <h2 className="it-section-title mb-30 text-danger">
                  Infection Prevention & Control & Hospital Waste Management
                </h2>

                <p className="lead mb-40 mt-30">
                  Develop knowledge and understanding of core IPC areas. Learn from leading experts in the field of infection prevention and control. Benefit from our state-of-the-art presentations and hands-on experience.
                </p>

                {/* Overview */}
                <section className="mb-50">
                  <h3 className="mb-20">Overview</h3>
                  <p className="mb-20">
                    Infection prevention and control (IPC) is fundamental to modern healthcare, and following events like the Covid-19 pandemic has become even more critical. The National Institute of Health (NIH), Pakistan outlines standards required to manage and reduce the risk of current and future events.
                  </p>
                  <p>
                    This workshop, developed and aligned to the National (NIH) and International guidelines (WHO & CDC) on infection prevention and control and Hospital Waste Management, will support you in gaining knowledge and understanding of core IPC areas.
                  </p>
                </section>

                {/* Registration Form */}
                <section className="mb-50">
                  <h3 className="mb-20 text-secondary">📝 Registration Form</h3>
                  <form
                    className="p-5 shadow-lg rounded bg-white border position-relative"
                    onSubmit={handleSubmit}
                  >
                    {loading && (
                      <div className="form-loading d-flex justify-content-center align-items-center">
                        <Loader2 size={40} className="text-primary spinner-border" />
                      </div>
                    )}
                    <div className="row g-4">
                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">First Name</label>
                        <input
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          className="form-control form-control-lg"
                          placeholder="Enter first name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">Last Name</label>
                        <input
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          className="form-control form-control-lg"
                          placeholder="Enter last name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                      <label className="form-label fw-bold text-muted">Email Address</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        className="form-control form-control-lg"
                        placeholder="Enter email address"
                        required
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-bold text-muted">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="form-control form-control-lg"
                        placeholder="Enter phone number"
                        required
                      />
                    </div>

                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">Designation</label>
                        <input
                          type="text"
                          name="designation"
                          value={formData.designation}
                          onChange={handleChange}
                          className="form-control form-control-lg"
                          placeholder="Enter designation"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">Gender</label>
                        <select
                          name="gender"
                          value={formData.gender}
                          onChange={handleChange}
                          className="form-select form-select-lg"
                          required
                        >
                          <option value="">Select Gender</option>
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">Age</label>
                        <input
                          type="number"
                          name="age"
                          value={formData.age}
                          onChange={handleChange}
                          className="form-control form-control-lg"
                          placeholder="Enter age"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">Institute Name</label>
                        <input
                          type="text"
                          name="institute"
                          value={formData.institute}
                          onChange={handleChange}
                          className="form-control form-control-lg"
                          placeholder="Enter institute name"
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold text-muted">Qualification</label>
                        <select
                          name="qualification"
                          className="form-select form-select-lg"
                          value={formData.qualification}
                          onChange={(e) => {
                            handleChange(e);
                            setQualification(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Qualification</option>
                          <option value="MBBS">MBBS</option>
                          <option value="Nursing">Nursing</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      {qualification === 'Other' && (
                        <div className="col-md-6">
                          <label className="form-label fw-bold text-muted">Other Qualification</label>
                          <input
                            type="text"
                            name="otherQualification"
                            value={formData.otherQualification}
                            onChange={handleChange}
                            className="form-control form-control-lg"
                            placeholder="Enter qualification"
                          />
                        </div>
                      )}
                      <div className="col-12">
                        <label className="form-label fw-bold text-muted">
                          Attachment (Proof of Payment)
                        </label>
                        <input
                          type="file"
                          name="attachment"
                          onChange={handleChange}
                          className="form-control form-control-lg"
                          required
                        />
                      </div>
                    </div>

                    <div className="alert alert-info mt-5 p-4 shadow-sm rounded">
                      <h5 className="fw-bold mb-3">🏦 Bank Account Details</h5>
                      <ul className="list-unstyled mb-2">
                        <li>
                          <b>Account Title:</b> Rawalpindi Institute of Cardiology
                        </li>
                        <li>
                          <b>Account Number:</b> 123456789
                        </li>
                        <li>
                          <b>Bank:</b> XYZ Bank
                        </li>
                      </ul>
                      <p className="fw-bold text-danger">💳 Fee: Rs. 10,000 / participant</p>
                    </div>

                    <div className="text-center mt-5">
                      <button
                        type="submit"
                        className="btn btn-lg btn-danger px-5 shadow d-flex align-items-center justify-content-center gap-2"
                      >
                        {loading ? (
                          <>
                            <Loader2 className="spinner-border spinner-border-sm" /> Submitting...
                          </>
                        ) : (
                          'Submit Registration'
                        )}
                      </button>
                    </div>
                  </form>
                </section>

                {/* Topics Covered */}
                <section className="mb-50">
                  <h3 className="mb-20">Topics Covered</h3>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="card h-100 shadow-sm p-4 text-center">
                        <Biohazard size={32} className="mb-3 text-danger" />
                        <h6 className="fw-bold mb-2">Core IPC Practices</h6>
                        <p className="small text-muted">Hand hygiene, PPE, safe injections, identification of high-risk areas.</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card h-100 shadow-sm p-4 text-center">
                        <ClipboardList size={32} className="mb-3 text-primary" />
                        <h6 className="fw-bold mb-2">Decontamination & Sterilization</h6>
                        <p className="small text-muted">Disinfection and sterilization practices with live demonstrations.</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card h-100 shadow-sm p-4 text-center">
                        <BookOpen size={32} className="mb-3 text-success" />
                        <h6 className="fw-bold mb-2">Antimicrobial Resistance</h6>
                        <p className="small text-muted">Understand multi-drug resistance and antimicrobial stewardship.</p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card h-100 shadow-sm p-4 text-center">
                        <Users size={32} className="mb-3 text-warning" />
                        <h6 className="fw-bold mb-2">Audits & Waste Management</h6>
                        <p className="small text-muted">Conduct IPC audits and adopt effective hospital waste management practices.</p>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-xl-3 col-lg-3 mb-50">
              <div className="it-sv-details__right">
                <div className="sidebar-wrap mb-60 p-relative">
                  <div className="sidebar-widget mb-45">
                    <h4 className="sidebar-widget-title mb-35">Quick Links</h4>
                    <div className="sidebar-widget-list">
                      <Link to="../certificates">Certifications</Link>
                      <Link to="../team">Our Doctors</Link>
                      <Link to="../event">Our Events</Link>
                      <Link to="../contact">Contact Us</Link>
                    </div>
                  </div>
                  {/* <div className="sidebar-widget mb-45">
                    <h4 className="sidebar-widget-title mb-35">Contact Us</h4>
                    <p>Medical Education Department</p>
                    <p>Rawalpindi Institute of Cardiology</p>
                    <p>Phone: 0519281374</p>
                    <p>Email: amsmedicaleducation@gmail.com</p>
                  </div> */}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Toast Container */}
    <ToastContainer
  position="top-right"
  autoClose={5000}       // disappear after 5 sec
  hideProgressBar={false} // show progress bar
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
  theme="light"
/>

      {/* Inline Styles */}
      <style>{`
        form input, form select {
          border-radius: 0.6rem !important;
          border: 1px solid #cfd8dc;
        }
        form label {
          margin-bottom: 6px;
          color: #006699;
        }
        .form-loading {
          position: absolute;
          inset: 0;
          background: rgba(255, 255, 255, 0.7);
          z-index: 10;
        }
        .toast-success {
          background-color: #e6ffed !important;
          color: #0f5132 !important;
          border-left: 6px solid #198754;
          font-weight: 500;
        }
        .toast-error {
          background-color: #fdecea !important;
          color: #842029 !important;
          border-left: 6px solid #dc3545;
          font-weight: 500;
        }
          .sidebar-widget{
padding:41px 20px;
}


.sidebar-widget-list a {
 
  transition: all 0.3s ease;
}

.sidebar-widget-list a:hover {
  background-color: var(--it-theme-color, #ee344e); /* use your theme’s primary */
  color: #fff;
  padding-left: 18px; /* subtle slide effect */
}


.sidebar-widget-title{
font-size:28px;
}
      `}</style>
    </main>
  );
};

export default InfectionPrevention;
